export default __webpack_public_path__ + "static/media/endurance.22809ab1.png";